import { config } from 'react-spring'

const IMAGES_COUNT = 12
const SPRITE_COLS = 4
const SPRITE_ROWS = 3

const SPRING_CONFIG = {
  config: config.wobbly,
  from: { transform: 'scale(0)' },
  to: { transform: 'scale(1)' },
}

export { IMAGES_COUNT, SPRING_CONFIG, SPRITE_COLS, SPRITE_ROWS }
